/** Compose event handlers into one that invokes each provided handler in order. */ export const chainHandlers = (...handlers)=>(event)=>{
        for (const handler of handlers){
            handler?.(event);
        }
    };
/**
 * Merge several refs (callback or object) into a single callback ref. Memoise the
 * result when used on an element so the ref isn't detached/reattached every render.
 */ export const mergeRefs = (...refs)=>(node)=>{
        for (const ref of refs){
            if (typeof ref === 'function') {
                ref(node);
            } else if (ref) {
                ref.current = node;
            }
        }
    };
/** React 19 exposes a cloned element's ref on `props.ref`. */ export const getElementRef = (element)=>element.props.ref;

//# sourceMappingURL=tooltip.utils.js.map